<template>
    <label
        class="inline-flex items-center gap-2"
        :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
    >
        <template v-if="size === 'large'">
            <input
                type="checkbox"
                v-bind="$attrs"
                class="sr-only peer disabled:cursor-not-allowed"
                :checked="checked"
                @change="$emit('update:modelValue', !checked)"
            />
            <div
                class="peer-disabled:cursor-not-allowed relative w-14 h-8 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:inset-s-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-primary"
            ></div>
        </template>
        <template v-if="size === 'normal'">
            <input
                type="checkbox"
                v-bind="$attrs"
                class="sr-only peer disabled:cursor-not-allowed"
                :checked="checked"
                @change="$emit('update:modelValue', !checked)"
            />
            <div
                class="peer-disabled:cursor-not-allowed relative w-10 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:inset-s-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"
            ></div>
        </template>
        <span
            class="select-none"
            :class="
                disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-800'
            "
        >
            {{ label }}
        </span>
    </label>
</template>

<script setup lang="ts">
    // Ref: https://flowbite.com/docs/forms/toggle/#sizes

    import { type PropType } from 'vue'

    defineOptions({
        inheritAttrs: false,
    })

    const props = defineProps({
        label: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String as PropType<'normal' | 'large'>,
            default: 'normal',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })
</script>
